var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * TrendingDown component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconTrendingDown extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.38482 6.00702C2.09193 5.71413 1.61706 5.71413 1.32416 6.00702C1.03127 6.29992 1.03127 6.77479 1.32416 7.06768L7.02094 12.7645L7.0263 12.7698C7.31237 13.0502 7.69699 13.2072 8.09757 13.2072C8.49815 13.2072 8.88279 13.0502 9.16886 12.7698L12.7595 9.17915C12.7651 9.17412 12.7723 9.17131 12.7799 9.17131C12.7874 9.17131 12.7947 9.17412 12.8002 9.17915L20.3339 16.7128H15.9011C15.4869 16.7128 15.1511 17.0486 15.1511 17.4628C15.1511 17.877 15.4869 18.2128 15.9011 18.2128H22.1442C22.2298 18.2128 22.3121 18.1985 22.3887 18.172C22.4932 18.1361 22.5914 18.0765 22.6748 17.9931C22.8266 17.8413 22.8997 17.6406 22.8942 17.4417V11.2197C22.8942 10.8055 22.5584 10.4697 22.1442 10.4697C21.73 10.4697 21.3942 10.8055 21.3942 11.2197V15.6518L13.8565 8.11404L13.8511 8.10878C13.5651 7.82838 13.1805 7.67131 12.7799 7.67131C12.3793 7.67131 11.9947 7.82835 11.7086 8.10876L8.11794 11.6994C8.11237 11.7044 8.10511 11.7072 8.09757 11.7072C8.09003 11.7072 8.08277 11.7044 8.0772 11.6994L2.38482 6.00702Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconTrendingDown.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconTrendingDown.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconTrendingDown.prototype, "size", void 0);
if (customElements.get('cat-icon-trending-down') === undefined) {
    customElements.define('cat-icon-trending-down', BlocksIconTrendingDown);
}
